<div class="container ms-3"> 
  <!-- Flex wrapper for button and heading -->
  <div class="d-flex align-items-center mb-5">
    <h6 class="text-start mx-1 mb-0">Sub Portals</h6>
    <button
      type="button"
      class="btn btn-primary text-xxs rounded-5 mx-2 btn-sm shadow"
      data-bs-toggle="modal"
      data-bs-target="#select_sub_portals_modal"
    >
      + Add Sub-Portals
    </button>
  </div>

  <!-- Check if master_portals is empty -->
  <div v-if="!master_portals.length" class="text-center">
    No available sub-portals.
  </div>

  <!-- Display list of sub-portals -->
  <div class="portal-list" v-else>
    <a v-for="portal in master_portals"
      :key="portal.id" 
      type="button" 
      class="btn portal-button text-xxs shadow">
      {{ portal.name }}
    </a>
  </div>
</div>

  


  <div class="modal fade" id="select_sub_portals_modal" tabindex="-1" aria-labelledby="selectPortalsLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="selectPortalsLabel">Select Sub-Portals</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
  
        <form @submit.prevent="editPortal">
          <div class="modal-body">
  
            <!-- Portals Table -->
            <table class="table table-striped text-xs">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Portal Name</th>
                  <th scope="col">
                    Action 
                    <span class="ms-2">
                      <input  
                        class="form-check-input" 
                        type="checkbox" 
                        id="select_all_checkbox" 
                        :checked="areAllSubPortalsSelected" 
                      @change="toggleSelectAllSubPortals"
                      />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(portal, index) in filteredPortals" :key="portal.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ portal.name }}</td>
                  <td>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'portal_check_' + portal.id" 
                        :value="portal.id" 
                        v-model="selectedPortals"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-5">Add Portals</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  